import { axiosV2 } from "config/@axios";
import * as logActions from "pages/Logs/store/logActions";

export const FETCH_LOGS = "logsActions::fetchLogs";
export const FETCH_LOGS_SUCCESS = "logsActions::fetchLogsSuccess";
export const FETCH_LOGS_FAILED = "logsActions::fetchLogsFailed";

export const fetchLogs =
  (params = null) =>
  (dispatch, getState) => {
    const state = getState();
    const searchParams = state.log.searchParams;

    const currentParams = {
      ...searchParams,
      ...params
    };

    Object.keys(currentParams).forEach(el => {
      if (currentParams[el] === "") {
        delete currentParams[el];
      }
    });

    dispatch({
      type: FETCH_LOGS
    });
    return axiosV2
      .get(`logs/mail`, { params: currentParams })
      .then(response => {
        const totalCount = parseInt(response.headers?.["x-total-count"]);
        dispatch({
          type: FETCH_LOGS_SUCCESS,
          payload: {
            logs: response.data,
            totalCount
          }
        });
        dispatch(logActions.setSearchParams(currentParams));
        dispatch(logActions.setOpenedRecipients({}));
      })
      .catch(err => {
        dispatch({
          type: FETCH_LOGS_FAILED,
          payload: {
            errorText: err.errorMessage
          }
        });
      });
  };
